/* 如果是微服务，需要思考清楚是否还需要使用相同的命名，是否需要带前缀 */
import eventLib from './index';

/* 监听navigate方法 */
export function onNavigate(callback) {
  if (!window.__POWERED_BY_QIANKUN__) { // 非qiankun内嵌时才需要挂载，不然主基座已经挂载
    eventLib.on('navigate', callback);
  }
}
export function onWindowOpen(callback) {
  eventLib.on('windowOpen', callback);
}
/* 监听 /msg 页面的全部已读接口调用 */
export function onMsgAllRead(callback) {
  eventLib.on('msgAllRead', callback);
}
